import React from 'react';

/**
 * GrillTheGridEpisodeSection - F1-specific section component for displaying Grill The Grid episodes
 * @param {Object} props
 * @param {string} props.title - Section title
 * @param {Array} props.episodes - Array of episode data objects with year, round, title, description, youtube_url
 * @param {string} props.className - Additional CSS classes
 */
const GrillTheGridEpisodeSection = ({ title, episodes, className = '' }) => {
  if (!episodes || episodes.length === 0) {
    return null;
  }

  // Extract YouTube video ID from URL
  const getYouTubeId = (url) => {
    if (!url) return null;
    const match = url.match(/(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/);
    return match ? match[1] : null;
  };

  return (
    <div className={`theme-bg rounded-lg shadow-md p-6 mb-6 ${className}`}>
      <h2 className="text-xl font-semibold theme-primary mb-4">{title}</h2>
      <div className="space-y-4">
        {episodes.map((episode, index) => {
          const youtubeId = getYouTubeId(episode.youtube_url);
          return (
            <div 
              key={index} 
              className="theme-bg-secondary rounded-lg p-4 border theme-border-secondary hover:border-opacity-50 transition-colors"
            >
              <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4">
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="px-2 py-1 bg-blue-600 text-white text-xs font-semibold rounded">
                      Round {episode.round}
                    </span>
                    <h3 className="font-semibold theme-primary">{episode.title}</h3>
                  </div>
                  {episode.description && (
                    <p className="theme-secondary text-sm mb-2">{episode.description}</p>
                  )}
                </div>
                {youtubeId && (
                  <div className="flex-shrink-0">
                    <a
                      href={episode.youtube_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-md transition-colors text-sm font-medium"
                    >
                      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"/>
                      </svg>
                      Watch on YouTube
                    </a>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default GrillTheGridEpisodeSection;
